import { Result } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../components/Breadcrumb";
import { getOrder } from "../redux/actions/orders";
import { formatDate } from "../utils/Utils";

const CheckOutSuccess = ({ storeCurrency }) => {
  const orderIdString = localStorage.getItem("orderId");
  const dispatch = useDispatch();
  let orderId = orderIdString?.substring(1, 25);

  useEffect(() => {
    dispatch(getOrder(orderId));
  }, [dispatch, orderId]);

  const orderDetails = useSelector((state) => state.orders)?.order;

  return (
    <div>
      <Breadcrumb heading={"Order Confirmation"} />
      <div className="container mx-auto">
        <div>
          <Result
            status="success"
            title="Thank you. Your order has been received."
          />
          <div className="checkout container mx-auto md:grid grid-cols-3 gap-8 my-4 p-4">
            <div className="bg-pink p-4 md:p-6">
              <h4 className="heading_h4 border-b pb-2">Order Info</h4>
              <ul>
                <li>
                  <p>Order ID</p>
                  <p>{orderDetails?._id}</p>
                </li>
                <li>
                  <p>Date</p>
                  <p>{formatDate(orderDetails?.createdAt)}</p>
                </li>
                <li>
                  <p>Total Amount Paid</p>
                  <p>
                    {storeCurrency}
                    {orderDetails?.totalPrice}
                  </p>
                </li>
                <li>
                  <p>Payment Method</p>
                  <p>{orderDetails?.paymentMethod}</p>
                </li>
                <li>
                  <p>Status</p>
                  <p>{orderDetails?.status}</p>
                </li>
              </ul>
            </div>
            <div className="bg-pink p-4 md:p-6">
              <h4 className="heading_h4 border-b pb-2">Billing Address</h4>
              <ul>
                <li>
                  <p>Address</p>
                  <p>{orderDetails?.billingAddress}</p>
                </li>
                <li>
                  <p>State</p>
                  <p>{orderDetails?.billingAddressState}</p>
                </li>
                <li>
                  <p>City</p>
                  <p>{orderDetails?.billingAddressCity}</p>
                </li>
                <li>
                  <p>Country</p>
                  <p>{orderDetails?.billingAddressCountry}</p>
                </li>
                <li>
                  <p>Postcode</p>
                  <p>{orderDetails?.billingAddressZip}</p>
                </li>
              </ul>
            </div>
            <div className="bg-pink p-4 md:p-6">
              <h4 className="heading_h4 border-b pb-2">Shipping Address</h4>
              <ul>
                <li>
                  <p>Address</p>
                  <p>{orderDetails?.shippingAddress}</p>
                </li>
                <li>
                  <p>State</p>
                  <p>{orderDetails?.shippingAddressState}</p>
                </li>
                <li>
                  <p>City</p>
                  <p>{orderDetails?.shippingAddressCity}</p>
                </li>
                <li>
                  <p>Country</p>
                  <p>{orderDetails?.shippingAddressCountry}</p>
                </li>
                <li>
                  <p>Postcode</p>
                  <p>{orderDetails?.shippingAddressZip}</p>
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="container mx-auto bg-pink p-4 md:p-6 my-8">
            <h4 className="heading_h4 border-b pb-2">Order Details</h4>
            <table className="table-auto w-full ">
              <thead className="border-b">
                <tr>
                  <th className="text-left pb-3" colSpan={4}>
                    Product
                  </th>
                  <th className="pb-3">Price</th>
                  <th className="pb-3">Quantity</th>
                </tr>
              </thead>
              <tbody>
                {orderDetails?.orderItems?.map((item, index) => (
                  <tr key={index}>
                    <td colSpan={4} className="py-4">
                      {item?.product?.name}
                    </td>
                    <td className="text-center py-4">x{item?.quantity}</td>
                    <td className="text-center py-4">
                      {storeCurrency}
                      {item?.product?.price}
                    </td>
                  </tr>
                ))}
                <tr className="border-b">
                  <td colSpan={5} className="py-4 font-bold">
                    Subtotal
                  </td>
                  <td className="text-center py-4">$2160.00</td>
                </tr>
                <tr className="border-b">
                  <td colSpan={5} className="py-4 font-bold">
                    Shipping
                  </td>
                  <td className="text-center py-4">Flat rate: $50.00</td>
                </tr>
                <tr>
                  <td colSpan={5} className="py-4 font-bold">
                    Total
                  </td>
                  <td className="text-center py-4">$2160.00</td>
                </tr>
              </tbody>
            </table>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default CheckOutSuccess;
